<template>
    <!-- Skeleton loader -->
    <div class="loading-skeleton">
        <!-- Header Section Skeleton -->
        <div class="skeleton-header-section">
        <div class="skeleton-header-top">
            <Skeleton width="200px" height="2rem" class="mb-2" />
            <div class="skeleton-status">
            <Skeleton width="120px" height="2rem" />
            </div>
        </div>
        
        <!-- Info Grid Skeleton -->
        <div class="skeleton-info-grid">
            <div class="skeleton-info-item">
            <Skeleton width="120px" height="1.2rem" class="mb-1" />
            <Skeleton width="150px" height="1.5rem" />
            </div>
            <div class="skeleton-info-item">
            <Skeleton width="100px" height="1.2rem" class="mb-1" />
            <Skeleton width="130px" height="1.5rem" />
            </div>
            <div class="skeleton-info-item">
            <Skeleton width="140px" height="1.2rem" class="mb-1" />
            <Skeleton width="160px" height="1.5rem" />
            </div>
            <div class="skeleton-info-item">
            <Skeleton width="110px" height="1.2rem" class="mb-1" />
            <Skeleton width="140px" height="1.5rem" />
            </div>
        </div>

        <!-- Actions Skeleton -->
        <div class="skeleton-actions">
            <Skeleton width="120px" height="2.5rem" class="mr-2" />
            <Skeleton width="120px" height="2.5rem" />
        </div>
        </div>

        <!-- Items Table Skeleton -->
        <div class="skeleton-table mt-4">
        <!-- Table Header -->
        <div class="skeleton-table-header">
            <Skeleton width="100%" height="3rem" />
        </div>
        
        <!-- Table Rows -->
        <div class="skeleton-table-body">
            <div v-for="n in 3" :key="n" class="skeleton-table-row">
            <Skeleton width="100%" height="4rem" class="mb-2" />
            </div>
        </div>
        </div>

        <!-- Summary Section Skeleton -->
        <div class="skeleton-summary mt-4">
        <div class="skeleton-summary-items">
            <div class="skeleton-summary-item">
            <Skeleton width="150px" height="1.2rem" class="mb-1" />
            <Skeleton width="100px" height="1.5rem" />
            </div>
            <div class="skeleton-summary-item">
            <Skeleton width="130px" height="1.2rem" class="mb-1" />
            <Skeleton width="120px" height="1.5rem" />
            </div>
        </div>
        </div>
    </div>
</template>
<style scoped>
.loading-skeleton {
  padding: 1.5rem;
}

/* Estilos del Skeleton */
.skeleton-header-section {
  background: transparent;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  margin-top: 70px;
}

.skeleton-header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.skeleton-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.skeleton-info-item {
  display: flex;
  flex-direction: column;
}

.skeleton-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.skeleton-table {
  background: var(--surface-card);
  border-radius: 6px;
  padding: 1rem;
}

.skeleton-table-header {
  margin-bottom: 1rem;
}

.skeleton-table-body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.skeleton-summary {
  background: var(--surface-card);
  border-radius: 6px;
  padding: 1rem;
}

.skeleton-summary-items {
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
}

</style>